import {gsap} from "gsap";
import {HTH} from "../../HTH";
import {HTHGameMode} from "../../server/HTHGameMode";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {HTHSound} from "../../sound/HTHSound";

export class HTHFSIntroPresentation implements SimplePresentation {
    name: string = "HTHFSIntroPresentation";

    shouldRun(): boolean {
        return (!HTH.model.isNextNormal && HTH.model.nextMode !== HTHGameMode.NORMAL_AVALANCHE) && (HTH.model.isNormal || HTH.model.mode === HTHGameMode.NORMAL_AVALANCHE);
    }

    start(controller: SimplePresentationRunnerController): void {
        const startIntroTl: gsap.core.Timeline = gsap.timeline();
        controller.setSkipCallback();
        startIntroTl.add(() => {
            HTHSound.switchMusic({name: HTHSound.BONUS_INTRO});
            HTHSound.playTrack(HTHSound.FS_INTRO_START);
        }, 0)
        startIntroTl.add(HTH.fsIntroView.showFSIntro(), 0);
        startIntroTl.add(HTH.transitionView.enableButton(() => this.complete(controller)), "<1");
    }

    public complete(controller: SimplePresentationRunnerController): void {
        const endIntroTl: gsap.core.Timeline = gsap.timeline();
        endIntroTl.add(() => {
            HTHSound.playSFSMusic(HTH.model.safeSymbols);
        }, 0);
        endIntroTl.add(HTH.fsIntroView.hideFSIntro(), 0);
        endIntroTl.add(() => {
            controller.setSkipCallback();
            HTH.keypadPlugin.show(0.2);
            controller.finish();
        });
    }
}